import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class UrlService {
  public previousUrl: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public secondPreviousUrl: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor() { }

  setPreviousUrl(previousUrl: string, secondPreviousUrl: string) {
    this.previousUrl.next(previousUrl);
    this.secondPreviousUrl.next(secondPreviousUrl);
  }
}
